export default "__VITE_ASSET__DsTQfpqe__"